import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import { apiFetch } from "./utils/api";
import "./ReminderPreview.css";

// The reminder email exactly as it is sent (built by the server; nothing is
// sent from here). Every recipient gets the same email, one each. The email
// is shown in a sandboxed frame: no scripts, links don't navigate the app.
// onSend (optional): a button that goes on to send (the usual confirmation
// still follows), labelled sendLabel.
export default function ReminderPreview({ formId, onClose, onSend, sendLabel }) {
    const [mail, setMail] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await apiFetch(`/api/reminders/${formId}/preview`, { method: "GET" });
                const body = await res.json();
                if (!res.ok) throw new Error(body.error || "Could not load the preview.");
                if (!cancelled) setMail(body);
            } catch (err) {
                if (!cancelled) setError(err.message);
            }
        })();
        return () => { cancelled = true; };
    }, [formId]);

    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [onClose]);

    const n = mail ? mail.recipients : 0;
    return createPortal(
        <div className="rp-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="rp-modal" role="dialog" aria-modal="true" aria-labelledby="rp-title">
                <div className="rp-head">
                    <div>
                        <div className="rp-title" id="rp-title">Email preview</div>
                        <div className="rp-sub">Reminder{mail ? ` · ${n} ${n === 1 ? "person" : "people"} pending (separate emails)` : ""}</div>
                    </div>
                    <button type="button" className="rp-close" aria-label="Close" onClick={onClose}><FaTimes /></button>
                </div>

                <div className="rp-body">
                    {error && <p className="rp-error">{error}</p>}
                    {!mail && !error && <p className="rp-loading">Loading the preview...</p>}
                    {mail && (
                        <>
                            <div className="rp-meta">
                                <div className="rp-row"><span className="rp-key">To:</span><span>&lt;Each person who hasn't responded&gt;<small>1 email per person, sent separately</small></span></div>
                                <div className="rp-row"><span className="rp-key">Sub:</span><span className="rp-subject">{mail.subject}</span></div>
                            </div>
                            {mail.blocked && <p className="rp-warn">Reminders can't be sent now: {mail.blocked}</p>}
                            <iframe className="rp-frame" title="Reminder email" sandbox="" srcDoc={mail.html} />
                        </>
                    )}
                </div>

                <div className="rp-foot">
                    <button type="button" className="rp-btn" onClick={onClose}>{onSend ? "Cancel" : "Close"}</button>
                    {onSend && (
                        <button type="button" className="rp-btn rp-btn-primary" disabled={!mail || !!mail.blocked}
                            onClick={() => { onClose(); onSend(); }}>
                            {sendLabel || "Send"}
                        </button>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
}
